import { DevToolsSectionHeader } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsSectionHeader';
import { CallsCard } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/CallsTab/CallsCard';
import type { CallsListProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/CallsTab/CallsList/index.types';
import React from 'react';

/**
 * CallsList - One titled, counted section of call cards
 *
 * Renders nothing when it is empty:
 */
export const CallsList: React.FC<CallsListProps> = ({
  title,
  calls,
  currentCallId,
}) => {
  if (calls.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2">
      <DevToolsSectionHeader title={title} count={calls.length} />
      {calls.map((call) => (
        <CallsCard
          key={call.id}
          call={call}
          isCurrentCall={call.id === currentCallId}
        />
      ))}
    </div>
  );
};
